import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppointmentModel } from "store/types/models";

const initialState = {
  appointment:{} as AppointmentModel,
  appointments:[] as AppointmentModel[],
};

export const appointmentSlice = createSlice({
  name: "AppointmentSlice",
  initialState: initialState,
  reducers: {
    setAppointment: (state, action:PayloadAction<AppointmentModel[]>) => {
      state.appointments = action.payload
    },
    addAppointment: (state, action:PayloadAction<AppointmentModel>) => {
      state.appointments.push(action.payload)
    },
  },
});

export const { setAppointment,addAppointment } = appointmentSlice.actions;

export default appointmentSlice.reducer;